function Checkmark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g>
        <path
          fill="#E42436"
          d="M7.279 13.47L2.896 9.08a.679.679 0 010-.954l.954-.954a.679.679 0 01.954 0l2.952 2.952 6.336-6.327a.679.679 0 01.954 0L16 4.75a.679.679 0 010 .954L8.242 13.47a.679.679 0 01-.954 0h-.01z"
        ></path>
      </g>
    </svg>
  );
}

export default Checkmark;
